// extracted by mini-css-extract-plugin
export default {"mmm":"Projects_mmm__a7V4O","main":"Projects_main__tuJ0X"};